module.exports = __webpack_public_path__ + "img/Patch18-2.18d442c1.webp";